var advance = function() {
  // Reset loading flag so next page can be triggered
  infinitescroll.loading = false;
  
  $th_refreshWishlistItems();
  
  if (window.innerWidth <= 991) {
    if (typeof initProductGridProgressBars === 'function') initProductGridProgressBars();
  }
  
  setTimeout(function() {
    document.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('scroll'));
    if (infinitescroll.instance && typeof infinitescroll.instance.checkIfPaginationInView === 'function') {
      infinitescroll.instance.checkIfPaginationInView();
    }
  }, 250);
  
  setTimeout(function() {
    if (infinitescroll.instance && typeof infinitescroll.instance.checkIfPaginationInView === 'function') {
      infinitescroll.instance.checkIfPaginationInView();
    }
  }, 800);
}
var infinitescroll = {
  instance: null,
  loading: false,
  scolljs: function(){
    var productGrid = document.querySelector('#product-grid');
    var pagination = document.querySelector('#AjaxinatePagination');
    
    if (!productGrid || !pagination) {
      return;
    }
    
    if (this.instance && typeof this.instance.destroy === 'function') {
      this.instance.destroy();
    }
    
    this.loading = false;
    this.instance = new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      callback: advance,
      offset: 1800
    });
    
    // Patch loadMore to prevent duplicate in-flight requests
    var origLoadMore = this.instance.loadMore.bind(this.instance);
    this.instance.loadMore = function() {
      if (infinitescroll.loading) return;
      infinitescroll.loading = true;
      origLoadMore();
    };
  }
}

infinitescroll.scolljs();

window.addEventListener('pageshow', function(event) {
  if (event.persisted) {
    infinitescroll.scolljs();
  }
});

document.addEventListener('click', function(e) {
  const productLink = e.target.closest('.product-link, .grid-meta-wrap a, .snippet-product-grid a');
  if (productLink) {
    const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
    const productGrid = document.querySelector('#product-grid');
    const paginationEl = document.querySelector('#AjaxinatePagination');

    if (productGrid) {
      try {
        sessionStorage.setItem(`${collectionHandle}-scrollPos`, window.scrollY);
        sessionStorage.setItem(`${collectionHandle}-gridHTML`, productGrid.innerHTML);
        // Save pagination state so Ajaxinate resumes from the correct next page
        sessionStorage.setItem(`${collectionHandle}-paginationHTML`, paginationEl ? paginationEl.innerHTML : '');
      } catch (err) {
        console.warn('SessionStorage quota exceeded, grid is too large to cache entirely.', err);
        // Gracefully clear out partial state to avoid corrupt HTML
        sessionStorage.removeItem(`${collectionHandle}-scrollPos`);
        sessionStorage.removeItem(`${collectionHandle}-gridHTML`);
        sessionStorage.removeItem(`${collectionHandle}-paginationHTML`);
      }
    }
  }
});

if (window.performance && window.performance.navigation.type == window.performance.navigation.TYPE_BACK_FORWARD) {
  const productGrid = document.querySelector('#product-grid');
  const paginationEl = document.querySelector('#AjaxinatePagination');
  const collectionHandle = document.body.getAttribute('data-collection-handle') || window.location.pathname;
  const savedScrollPos = sessionStorage.getItem(`${collectionHandle}-scrollPos`);
  const savedGridHTML = sessionStorage.getItem(`${collectionHandle}-gridHTML`);
  const savedPaginationHTML = sessionStorage.getItem(`${collectionHandle}-paginationHTML`);

  if (savedGridHTML && savedScrollPos) {
    // Destroy Ajaxinate BEFORE touching the DOM so it cannot fire a load
    // in response to the scroll we're about to trigger.
    if (infinitescroll.instance && typeof infinitescroll.instance.destroy === 'function') {
      infinitescroll.instance.destroy();
      infinitescroll.instance = null;
    }

    // Restore the full grid as the user left it
    productGrid.innerHTML = savedGridHTML;

    // The saved HTML already has data-progress-init="1" stamped on every
    // scroll container from when they were first initialised. Clear those
    // flags so initProductGridProgressBars() re-attaches listeners.
    if (window.innerWidth <= 991) {
      productGrid.querySelectorAll('[data-progress-init]').forEach(el => el.removeAttribute('data-progress-init'));
      if (typeof initProductGridProgressBars === 'function') initProductGridProgressBars(productGrid);
    }

    // Restore pagination to the exact page the user was on so Ajaxinate
    // will load the correct *next* page (not re-load an already-shown page)
    if (paginationEl) {
      if (savedPaginationHTML) {
        paginationEl.innerHTML = savedPaginationHTML;
      } else {
        // No next page existed — hide pagination entirely
        paginationEl.style.display = 'none';
      }
    }

    window.scrollTo(0, savedScrollPos);

    // Re-init Ajaxinate now that grid + pagination are in their correct state
    infinitescroll.scolljs();

    // Re-attach colour-swatch hover + wishlist handlers for restored items
    if (typeof advance === 'function') try { advance(); } catch(e) {}

    // Cleanup
    sessionStorage.removeItem(`${collectionHandle}-scrollPos`);
    sessionStorage.removeItem(`${collectionHandle}-gridHTML`);
    sessionStorage.removeItem(`${collectionHandle}-paginationHTML`);
  }
};


let filterForm = document.querySelector("facet-filters-form");
let filter = filterForm ? filterForm.offsetTop : 0;
var lastscroll = 0;
var scrollTicking = false;

window.addEventListener("scroll", () => {
  let scrollcount = window.pageYOffset;
  if (!scrollTicking) {
    window.requestAnimationFrame(() => {
      (scrollcount >= filter) ? document.body.classList.add("filter-sticky") : document.body.classList.remove("filter-sticky");
      
      let headerGroup = document.querySelector('.header-group');
      let collectionFilter = document.querySelector('.snippet-collection-filter');
      
      if (collectionFilter && headerGroup) {
        if(scrollcount > lastscroll){
          collectionFilter.style.top = '0px';
        } else if(scrollcount < lastscroll){
          let offset = window.innerWidth < 992 ? 35 : 40;
          collectionFilter.style.top = (headerGroup.clientHeight - offset) + 'px';
        }
      }
      lastscroll = scrollcount;
      scrollTicking = false;
    });
    scrollTicking = true;
  }
});